import { initContract } from '@ts-rest/core'
import { z } from 'zod'

const c = initContract()
const prefix = '/v2/integrations/one-community'

// Schema definitions
export const FormSchema = z
  .object({
    id: z.number().optional(),
    date: z.string().optional(),
    label: z.string().optional(),
  })
  .passthrough()

export const EndUserIntegrationSchema = z
  .object({
    id: z.string(),
    campaignId: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    firstName: z.string().optional().nullable(),
    middle: z.string().optional().nullable(),
    lastName: z.string().optional().nullable(),
    address: z.any().optional().nullable(),
    birthday: z.string().optional().nullable(),
    campaignIncentiveId: z.string().optional().nullable(),
    questionnaireAnswers: z.any().optional().nullable(),
    referralOf: z.string().optional().nullable(),
    happinessAnswers: z.any().optional().nullable(),
    phoneNumber: z.string().optional().nullable(),
    sku: z.string().optional().nullable(),
    digitalCode: z.string().optional().nullable(),
    postnlCode: z.string().optional().nullable(),
    referenceCode: z.number().optional().nullable(),
    uniqueCode: z.string().optional().nullable(),
    optionalData: z.any().optional().nullable(),
    isTest: z.boolean().optional().nullable(),
  })
  .passthrough()

export const DateRangeSchema = z.object({
  from: z.union([z.string(), z.date()]),
  to: z.union([z.string(), z.date()]),
})

const ValidationErrorSchema = z.object({
  user: z.string(),
  missingFields: z.array(z.string()),
})

// Contract
export const endUsersIntegrations = c.router({
  getForms: {
    method: 'GET',
    path: `${prefix}/forms/:campaignId`,
    pathParams: z.object({
      campaignId: z.string(),
    }),
    responses: {
      200: z.array(FormSchema),
      401: z.object({ message: z.string() }),
      404: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Get OneCommunity forms for a campaign',
  },
  getFormEntities: {
    method: 'GET',
    path: `${prefix}/form-entities/:campaignId`,
    pathParams: z.object({
      campaignId: z.string(),
    }),
    query: z.object({
      formIds: z.union([z.string(), z.number().transform(String)]).optional(), // Comma-separated string of form IDs, or single number
    }),
    responses: {
      200: z.object({
        endUsers: z.array(EndUserIntegrationSchema),
        total: z.number(),
      }),
      400: z.array(ValidationErrorSchema),
      401: z.object({ message: z.string() }),
      404: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Get OneCommunity form entities',
  },
  getPurchases: {
    method: 'POST',
    path: `${prefix}/purchases/:campaignId`,
    pathParams: z.object({
      campaignId: z.string(),
    }),
    body: DateRangeSchema,
    responses: {
      200: z.object({
        endUsers: z.array(EndUserIntegrationSchema),
        total: z.number(),
      }),
      400: z.array(ValidationErrorSchema),
      401: z.object({ message: z.string() }),
      404: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Get OneCommunity purchases',
  },
  getThreeDrawsAndPrize: {
    method: 'GET',
    path: `${prefix}/three-draws-prize/:campaignId`,
    pathParams: z.object({
      campaignId: z.string(),
    }),
    query: z.object({
      createdAt: z.string(),
    }),
    responses: {
      200: z.object({
        endUsers: z.array(EndUserIntegrationSchema),
        total: z.number(),
      }),
      400: z.array(ValidationErrorSchema),
      401: z.object({ message: z.string() }),
      404: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Get OneCommunity three draws and prize data',
  },
})
